/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPin = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m13.5 1.1-3.1 3.2.6 2.1-2.8 2.7H4.1l-2.3 2.4 4.1 4.1-4.1 4.1 1.4 1.4L7.3 17l4.1 4.1 2.4-2.4v-4l2.8-2.8 2.1.7 3.2-3.2zm4.5 9.2-2-.7-4.2 4.3v4l-.4.4-6.8-6.8.4-.4h4l4.2-4.2-.7-2.1 1-.8L19 9.5z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgPin as Pin };
